import type { AiStrategy } from './types';

export interface AiBalanceProfile {
  cashReserveMultiplier: number;
  downPaymentRatio: number;
  maxDecisionsPerWeek: number;
  routeCloseThreshold: number;
  hubExpansionFleet: number;
}

export const AI_BALANCE: Record<AiStrategy, AiBalanceProfile> = {
  basic: { cashReserveMultiplier: 1, downPaymentRatio: 0.5, maxDecisionsPerWeek: 2, routeCloseThreshold: -0.18, hubExpansionFleet: 12 },
  advanced: { cashReserveMultiplier: 0.9, downPaymentRatio: 0.35, maxDecisionsPerWeek: 3, routeCloseThreshold: -0.12, hubExpansionFleet: 10 },
  strategic: { cashReserveMultiplier: 0.75, downPaymentRatio: 0.25, maxDecisionsPerWeek: 4, routeCloseThreshold: -0.08, hubExpansionFleet: 8 },
  elite: { cashReserveMultiplier: 0.65, downPaymentRatio: 0.3, maxDecisionsPerWeek: 5, routeCloseThreshold: -0.05, hubExpansionFleet: 7 },
};
